// extracted by mini-css-extract-plugin
export default {"playerGrid":"playerGrid-LvIa2dp7","playerOption":"playerOption-NNnNheF6","selected":"selected-xfsBUk3g","playerAvatar":"playerAvatar-mS0ZMktc","playerName":"playerName-rvYOEF5z"};